import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppFacturaDetalleExtra = Loadable(lazy(() => import('./view/FacturaDetalleExtra/FacturaDetalleExtra')))
const AppParametroSistema = Loadable(lazy(() => import('./view/ParametrosSistema/ParametroSistema')))
const AppMisMetodosPago = Loadable(lazy(() => import('./view/MisMetodosPago/MisMetodosPago')))
export const configuracionRoutesMap = {
  parametrosSistema: {
    path: '/configuracion/parametros-sistema',
    name: 'Parámetros del sistema',
    actionSecure: 'administrar',
  },
  detalleExtra: {
    path: '/configuracion/facturaDetalleExtra',
    name: 'Factura Detalle Extra',
    actionSecure: 'administrar',
  },
  misMetodosPago: {
    path: '/configuracion/misMetodosPago',
    name: 'Mis métodos de pago',
    actionSecure: 'administrar',
  },
}
const configuracionRoutes = [
  {
    path: configuracionRoutesMap.detalleExtra.path,
    element: <AppFacturaDetalleExtra />,
    auth: authRoles.admin,
  },
  {
    path: configuracionRoutesMap.parametrosSistema.path,
    element: <AppParametroSistema />,
    auth: authRoles.admin,
  },
  {
    path: configuracionRoutesMap.misMetodosPago.path,
    element: <AppMisMetodosPago />,
    auth: authRoles.admin,
  },
]

export default configuracionRoutes
